/* Presale countdown banner (Tuxedo Tiger Comics). Data comes from presale_drop metaobjects. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.TTPresaleCountdown = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';
  var fmtCache = {};
  function fmt(tz) {
    if (!fmtCache[tz]) {
      fmtCache[tz] = new Intl.DateTimeFormat('en-US', {
        timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
    }
    return fmtCache[tz];
  }
  // Wall-clock parts of instant ms in tz.
  function parts(ms, tz) {
    var o = {};
    fmt(tz).formatToParts(new Date(ms)).forEach(function (p) { if (p.type !== 'literal') o[p.type] = parseInt(p.value, 10); });
    if (o.hour === 24) o.hour = 0;
    return o;
  }
  // tz offset (ms) at instant: local wall time minus UTC.
  function offsetAt(ms, tz) {
    var p = parts(ms, tz);
    return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - Math.floor(ms / 1000) * 1000;
  }
  // UTC instant for local midnight in tz, `daysBefore` calendar days before the local date of dropMs. DST-safe.
  function windowStart(dropMs, tz, daysBefore) {
    var p = parts(dropMs, tz);
    var wall = Date.UTC(p.year, p.month - 1, p.day - (daysBefore == null ? 1 : daysBefore), 0, 0, 0);
    var guess = wall - offsetAt(wall, tz);
    var fixed = wall - offsetAt(guess, tz);
    return fixed;
  }
  // Soonest future drop; returns {drop, start, end, visible}.
  function pick(drops, nowMs, tz, daysBefore) {
    var future = (drops || []).filter(function (d) { return d && isFinite(d.ts) && d.ts * 1000 > nowMs; })
      .sort(function (a, b) { return a.ts - b.ts; });
    if (!future.length) return null;
    var d = future[0], end = d.ts * 1000, start = windowStart(end, tz, daysBefore);
    return { drop: d, start: start, end: end, visible: nowMs >= start && nowMs < end };
  }
  function split(msLeft) {
    var s = Math.max(0, Math.floor(msLeft / 1000));
    return { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function init(el) {
    if (!el || el.__ttInit) return; el.__ttInit = true;
    var dataEl = el.querySelector('script[type="application/json"]');
    var drops; try { drops = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var tz = el.getAttribute('data-tz') || 'America/Denver';
    var daysBefore = parseInt(el.getAttribute('data-days-before') || '1', 10);
    var skew = 0; // fake-now offset for previews
    try {
      var q = new URLSearchParams(window.location.search).get('countdown_test');
      // Previews only: unpublished/preview theme, theme editor, or explicitly allowed in section settings.
      var role = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || '';
      var allow = el.getAttribute('data-allow-test') === 'true' || (role && role !== 'main') || !!(window.Shopify && window.Shopify.designMode);
      if (q && allow) { var t = Date.parse(q); if (isFinite(t)) skew = t - Date.now(); }
    } catch (e) {}
    var now = function () { return Date.now() + skew; };
    var q$ = function (s) { return el.querySelector(s); };
    var titleEl = q$('[data-cd-title]'), linkEl = q$('[data-cd-link]'), imgEl = q$('[data-cd-img]');
    var units = { d: q$('[data-cd-d]'), h: q$('[data-cd-h]'), m: q$('[data-cd-m]'), s: q$('[data-cd-s]') };
    var current = null, timer = null, wakeTimer = null;

    function hide() { el.hidden = true; document.documentElement.classList.remove('tt-countdown-on'); }
    function show(d) {
      if (titleEl) titleEl.textContent = d.title || '';
      if (linkEl) { if (d.url) { linkEl.href = d.url; linkEl.hidden = false; } else linkEl.hidden = true; }
      if (imgEl) { if (d.img) { if (imgEl.getAttribute('src') !== d.img) imgEl.src = d.img; imgEl.alt = d.title || ''; imgEl.hidden = false; } else imgEl.hidden = true; }
      el.hidden = false; document.documentElement.classList.add('tt-countdown-on');
    }
    function tick() {
      var n = now();
      if (!current || n >= current.end) return evaluate();
      var t = split(current.end - n);
      if (units.d) units.d.textContent = t.d;
      if (units.h) units.h.textContent = pad(t.h);
      if (units.m) units.m.textContent = pad(t.m);
      if (units.s) units.s.textContent = pad(t.s);
    }
    function evaluate() {
      clearInterval(timer); clearTimeout(wakeTimer); timer = null;
      var n = now(), r = pick(drops, n, tz, daysBefore);
      current = null;
      if (!r) return hide();
      if (r.visible) {
        current = r; show(r.drop); tick();
        timer = setInterval(tick, 1000);
      } else {
        hide();
        var wait = r.start - n; // sleep until the window opens (max ~24.8 days for setTimeout)
        if (wait > 0 && wait < 2147483000) wakeTimer = setTimeout(evaluate, wait + 50);
      }
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) evaluate(); });
    evaluate();
    el.__ttEvaluate = evaluate;
  }
  function boot() { document.querySelectorAll('[data-tt-presale-countdown]').forEach(init); }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  }
  return { windowStart: windowStart, pick: pick, split: split, parts: parts, init: init };
});
